import React from "react";
import notFound from "../assets/images/404.png";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <>
      <div
        className="flex flex-col justify-center min-h-[100vh] dark:bg-black bg-white items-center w-full z-[100] bg-no-repeat gap-[120px] lg:bg-[position:left_bottom] lg:bg-[length:65%] bg-cover bg-[position:15%_20%]"
        style={{ backgroundImage: `url(${notFound})` }}
      >
        <div className="w-[145px] text-center rounded-full relative dark:bg-[linear-gradient(to_right,rgba(255,255,255,0.5)_10%,rgba(255,255,255,0))] bg-[linear-gradient(to_right,#000000_5%,rgba(255,255,255,0)_90%)] p-[1.5px] rounded-[40px]">
          <div className="p-[6px] rounded-[40px] dark:bg-black bg-white">
            <h2 className="lg:text-[17.44px] text-[14px] leading-[140%] tracking-[0.02em] font-normal font-DMMono dark:text-white/70 text-black py-[5px] px-[15px]">
              Error Page
            </h2>
          </div>
        </div>
        <h2 className="bg-[linear-gradient(273.43deg,#eb3366,#57249c,#00ffff,#ffffff)] bg-clip-text text-transparent font-semibold text-[110px] tracking-[-0.02em] lg:px-0 px-10 text-center align-middle lg:leading-[90%] leading-[100%]">
          404
        </h2>
        <Link
          to="/"
          className={`bg-[linear-gradient(86.72deg,#57249C_-10.66%,#EB3366_113.47%)] !text-white flex items-center justify-center font-semibold text-[14px] font-[400] py-[12px] rounded w-[137px] rounded-full transition duration-300 ease-in-out hover:scale-[1.1] `}
        >
          Back Home
        </Link>
      </div>
    </>
  );
}
